require('./global/announcements.js');
require('./global/sticky-header.js');
require('./global/language-switcher.js');
require('./global/menu.js');
require('./global/scroll-link.js');
require('./global/link.js');
require('./global/search.js');
require('./global/trustlogos.js');
require('./components/accordion.js');
require('./components/image.js');
require('./components/video-modal.js');
require('./components/modal.js');
require('./components/services.js');
// require('./global/third-party.js');